"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
interface CustomWeaveCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  primaryLabel: string;
  secondaryLabel: string;
  note: string;
}
const copyData: Record<Lang, CustomWeaveCopy> = {
  en: {
    eyebrow: "B2B Technical Support",
    heading: "Need help selecting or customizing a weave pattern?",
    lead: "Share your micron rating, differential pressure thresholds, and environmental requirements with our application team. We calculate wire diameters, open area percentages, and deliver production-ready mesh specifications.",
    primaryLabel: "Request a custom quote",
    secondaryLabel: "Consult with an engineer",
    note: "Manufactured to ASTM E2016 and ISO 9044 standards; slit coils and stamped discs available."
  },
  zh: {
    eyebrow: "B2B 工业技术支持",
    heading: "需要协助选型或定制特殊编织结构？",
    lead: "告知我们您的过滤精度、工况压降及工作介质要求。我们的技术工程师为您核算丝径、开孔率与机械强度，提供量产级工程规格书与报价方案。",
    primaryLabel: "索取定制报价",
    secondaryLabel: "咨询技术工程师",
    note: "严格符合 ASTM E2016 与 ISO 9044 国际标准，支持精密分条与冲压滤圆片定制。"
  },
  es: {
    eyebrow: "Soporte técnico B2B",
    heading: "¿Necesita ayuda para seleccionar o personalizar un patrón de tejido?",
    lead: "Comparta su clasificación micrométrica, límites de presión diferencial y requisitos ambientales. Calculamos diámetros de alambre y porcentaje de área abierta para entregar especificaciones listas para producción.",
    primaryLabel: "Solicitar presupuesto personalizado",
    secondaryLabel: "Consultar con un ingeniero",
    note: "Fabricado según ASTM E2016 e ISO 9044; bobinas cortadas y discos estampados disponibles."
  },
  de: {
    eyebrow: "B2B Technischer Support",
    heading: "Benötigen Sie Unterstützung bei der Auswahl oder Anpassung eines Webmusters?",
    lead: "Teilen Sie uns Ihre Mikron-Einstufung, Differenzdruckgrenzen und Betriebsbedingungen mit. Unser Team berechnet Drahtdurchmesser sowie freie Siebfläche und liefert produktionsreife Spezifikationen.",
    primaryLabel: "Individuelles Angebot anfordern",
    secondaryLabel: "Ingenieur konsultieren",
    note: "Konform mit ASTM E2016 und ISO 9044; Spaltbänder und gestanzte Ronden erhältlich."
  },
  fr: {
    eyebrow: "Support technique B2B",
    heading: "Besoin d'aide pour sélectionner ou personnaliser une structure de tissage ?",
    lead: "Indiquez votre seuil de filtration, vos contraintes de pression différentielle et vos conditions de service. Notre équipe calcule les diamètres de fils et le pourcentage de vide pour vos spécifications.",
    primaryLabel: "Demander un devis personnalisé",
    secondaryLabel: "Consulter un ingénieur",
    note: "Conforme aux normes ASTM E2016 et ISO 9044 ; bobines refendues et disques découpés disponibles."
  },
  pt: {
    eyebrow: "Suporte técnico B2B",
    heading: "Precisa de ajuda para selecionar ou personalizar um padrão de tecelagem?",
    lead: "Informe sua retenção micrométrica, limites de pressão diferencial e requisitos operacionais. Nossa equipe calcula diâmetros de arame e área aberta entregando especificações prontas para produção.",
    primaryLabel: "Solicitar cotação personalizada",
    secondaryLabel: "Consultar um engenheiro",
    note: "Fabricado conforme as normas ASTM E2016 e ISO 9044; bobinas cortadas e discos estampados disponíveis."
  }
};
export default function CustomWeave() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, copyData);
  return <CtaBand id="customweavecta" eyebrow={content.eyebrow} heading={content.heading} lead={content.lead} primary={{
    label: content.primaryLabel,
    to: "/RequestAQuotePage"
  }} secondary={{
    label: content.secondaryLabel,
    to: "/ContactPage"
  }} note={content.note} />;
}